// Packages
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Button,
  Card,
} from "reactstrap";
import axios from "axios";
import UserMetadataForm from "../components/forms/user-metadata";
// Utils
import { catchHandler, getRequestHeaders } from "../utils";
import { validationSchemaUserMetadata } from "../components/forms/schemas/user-metadata";
// Styling
import "./Profile.css";

const Profile = React.memo((props) => {
  const rootPathname = useMemo(() => "/", []);
  const [loading, setLoading] = useState(true);
  const [validated, setValidated] = useState(false);
  const [userMetadata, setUserMetadata] = useState(null);
  const [membershipId, setMembershipId] = useState(null);
  const history = useHistory();
  const catchHandlerBinded = catchHandler.bind(null, history);
  const formRef = useRef(null);

  useEffect(() => {
    axios
      .get(`/api/users/get-profile`, getRequestHeaders())
      .then((res) => {
        const { data = {} } = res;
        const { membershipId = "", metadata = {} } = data;

        setUserMetadata(metadata);
        setMembershipId(membershipId);
      })
      .catch(catchHandlerBinded)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onSubmit = useCallback(
    (event) => {
      event.preventDefault();

      setValidated(true);

      const formValues = formRef.current.values;
      formRef.current.validateForm();

      try {
        validationSchemaUserMetadata.validateSync(formValues);

        setLoading(true);

        axios
          .patch(
            `/api/users/edit-profile`,
            { metadata: formValues },
            getRequestHeaders()
          )
          .then(() => {
            validationSchemaUserMetadata;
            toast.success("Profilul a fost modificat cu succes");
            history.push(rootPathname);
          })
          .catch(catchHandler)
          .finally(() => {
            setLoading(false);
          });
      } catch (error) {
        // Form is invalid
      }
    },
    [formRef, history, rootPathname]
  );

  const onChangePasswordClick = useCallback(() => {
    history.push("/change-password");
  }, [history]);

  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col sm="12" lg={{ size: 10, offset: 1 }}>
          <Card className="p-5 bg-light shadow-sm">
            <h2 className="mb-5 mx-auto text-center">Administrare Profil {membershipId && `(ID: ${String(membershipId).padStart(7, "0")})`}</h2>

            {userMetadata ? (
              <UserMetadataForm
                formRef={formRef}
                initialValues={userMetadata}
                validated={validated}
                disabledPrimaryFields
              >
                <FormGroup className="d-flex justify-content-between mt-5">
                  <div className="button-container-left">
                    <Button
                      type="submit"
                      color="primary"
                      onClick={onSubmit}
                      disabled={loading}
                    >
                      Salvare
                    </Button>
                  </div>
                  <Button color="warning" onClick={onChangePasswordClick}>
                    Schimbare Parola
                  </Button>
                </FormGroup>
              </UserMetadataForm>
            ) : null}
          </Card>
        </Col>
      </Row>
    </Container>
  );
});

export default Profile;
